/**
 * 環境変数管理
 * APIキーはサーバーサイド(Cloudflare Pages Functions)で管理
 * フロントエンドにはAPIキーを含めない
 */

import { logger } from '../utils/logger';

interface AppConfig {
  isDev: boolean;
  isProduction: boolean;
  isTestMode: boolean;
}

class ConfigManager {
  private static instance: ConfigManager;
  private config: AppConfig;

  private constructor() {
    this.config = {
      isDev: import.meta.env.DEV,
      isProduction: import.meta.env.PROD,
      isTestMode: import.meta.env.VITE_TEST_MODE === 'true',
    };

    logger.info('CONFIG', '設定読み込み完了', {
      environment: this.config.isDev ? 'development' : 'production',
      testMode: this.config.isTestMode ? '有効' : '無効',
      apiKeyLocation: 'サーバーサイド（Cloudflare Pages Functions）',
    });
  }

  public static getInstance(): ConfigManager {
    if (!ConfigManager.instance) {
      ConfigManager.instance = new ConfigManager();
    }
    return ConfigManager.instance;
  }

  get isDev(): boolean {
    return this.config.isDev;
  }

  get isProduction(): boolean {
    return this.config.isProduction;
  }

  get isTestMode(): boolean {
    return this.config.isTestMode;
  }

  // 設定情報の表示
  public getConfigSummary() {
    return {
      environment: this.config.isDev ? 'development' : 'production',
      testMode: this.config.isTestMode ? '有効' : '無効',
      apiKeyLocation: 'サーバーサイド',
    };
  }
}

// API設定定数
export const API_SETTINGS = {
  OPENAI: {
    TEMPERATURE: 1.0,
    MAX_TOKENS: 2000,
  },
  FAL: {
    GUIDANCE_SCALE: 4.0,
    NUM_IMAGES: 1,
    IMAGE_SIZE: {
      WIDTH: 1440,
      HEIGHT: 810
    }
  }
} as const;

// シングルトンインスタンスのエクスポート
export const config = ConfigManager.getInstance();
